import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap'
import { connect } from 'react-redux'

import { } from '../actions'
import { } from '../utils'

class ComponentCreditCardInput extends Component {

    onNameInputChange(value) {
        this.props.setParentState('name', value)
    }

    renderNameInput() {
        return (
            <div>
                <label>ชื่อ - นามสกุล (ภาษาอังกฤษ)</label>
                <input onChange={e => { this.onNameInputChange(e.target.value) }} value={this.props.name} placeholder='ชื่อ - นามสกุล (ภาษาอังกฤษ)' className="form-control" type='text' />
            </div>
        )
    }

    renderDateInput() {
        return (
            <div>
                <label>เดือนที่หมดอายุ/ปีที่หมดอายุ/CCV</label>
                <Row>
                    <div style={{ display: 'inline-block', padding: 4, paddingLeft: 15 }}>
                        <input placeholder='MM' onChange={e => { this.onCreditCardInputChange(e, 5) }} ref={(input) => { this.input5 = input; }} value={this.props.input5} maxLength='2' className="form-control" style={{ width: 59, height: 30 }} type='text' />
                    </div>
                    <div style={{ display: 'inline-block', padding: 4 }}>
                        <input placeholder='YY' onChange={e => { this.onCreditCardInputChange(e, 6) }} ref={(input) => { this.input6 = input; }} value={this.props.input6} maxLength='2' className="form-control" style={{ width: 59, height: 30 }} type='text' />
                    </div>
                    <div style={{ display: 'inline-block', padding: 4 }}>
                        <input placeholder='CCV' onChange={e => { this.onCreditCardInputChange(e, 7) }} ref={(input) => { this.input7 = input; }} value={this.props.input7} maxLength='3' className="form-control" style={{ width: 59, height: 30 }} type='text' />
                    </div>
                </Row>
            </div>
        )
    }

    focusNext(input) {
        this[input].focus()
    }

    onCreditCardInputChange(e, num) {
        let state = 'input' + num
        var isnum = /^\d+$/.test(e.target.value)
        let num5 = true
        let num6 = true

        if (num == 5) {
            if ((e.target.value).length == 1) {
                Number(e.target.value) < 2 ? '' : num5 = false
            } else {
                Number(e.target.value) < 13 ? '' : num5 = false
            }
        }

        if (num == 6) {
            if ((e.target.value).length == 1) {
                Number(e.target.value) > 0 ? '' : num6 = false
            } else {
                Number(e.target.value) > 16 || e.target.value == '' ? '' : num6 = false
            }
        }

        if ((isnum || e.target.value == '') && num5 && num6) {
            this.props.setParentState(state, e.target.value)
            if (num < 5) {
                if ((e.target.value).length == 4) {
                    this.focusNext('input' + (num + 1))
                }
            } else if (num < 7) {
                if ((e.target.value).length == 2) {
                    this.focusNext('input' + (num + 1))
                }
            }
        }
    }

    renderCreditCardNumber() {
        return (
            <div>
                <label>เลขบัตรเครดิต</label>
                <Row>
                    <div style={{ display: 'inline-block', paddingLeft: 15 }}>
                        <input onChange={e => { this.onCreditCardInputChange(e, 1) }} value={this.props.input1} maxLength='4' className="form-control" style={{ width: 59, height: 30 }} type='text' />
                    </div>
                    <div style={{ display: 'inline-block', padding: 4 }}>
                        -
                    </div>
                    <div style={{ display: 'inline-block' }}>
                        <input onChange={e => { this.onCreditCardInputChange(e, 2) }} ref={(input) => { this.input2 = input; }} value={this.props.input2} maxLength='4' className="form-control" style={{ width: 59, height: 30 }} type='text' />
                    </div>
                    <div style={{ display: 'inline-block', padding: 4 }}>
                        -
                    </div>
                    <div style={{ display: 'inline-block' }}>
                        <input onChange={e => { this.onCreditCardInputChange(e, 3) }} ref={(input) => { this.input3 = input; }} value={this.props.input3} maxLength='4' className="form-control" style={{ width: 59, height: 30 }} type='text' />
                    </div>
                    <div style={{ display: 'inline-block', padding: 4 }}>
                        -
                    </div>
                    <div style={{ display: 'inline-block' }} >
                        <input onChange={e => { this.onCreditCardInputChange(e, 4) }} ref={(input) => { this.input4 = input; }} value={this.props.input4} maxLength='4' className="form-control" style={{ width: 59, height: 30 }} type='text' />
                    </div>
                </Row>
            </div>
        )
    }

    render() {
        return (
            <div>
                {this.renderNameInput()}
                <br />
                {this.renderCreditCardNumber()}
                <br />
                {this.renderDateInput()}
                <br />
            </div>
        )
    }

}

export default connect(null, {})(ComponentCreditCardInput)



// WEBPACK FOOTER //
// ./src/components/component_credit_card_input.js